module.exports = __webpack_public_path__ + "img/糖尿病.67405bcb.png";